import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import { DocSignRequestType, DocSignResponseType } from 'app/utils/services/types/docSign.type';

const docSignService = async (data: { data: DocSignRequestType; url: string }): Promise<DocSignResponseType> => {
  try {
    const result = await httpClient.post<DocSignResponseType>(data.url, data.data);

    return result;
  } catch (err: any) {
    if (err?.response.status === 400) {
      return err?.response.data;
    }
  }
};

export const useDocSignService = () => {
  const {
    isLoading: isLoadingDocSign,
    data: dataDocSign,
    mutate: docSignMutation,
  } = useMutation(['docSign'], (data: { data: DocSignRequestType; url: string }) => docSignService(data));

  return { isLoadingDocSign, dataDocSign, docSignMutation };
};
